import { Api } from "@/utils/Api";
import { env } from "@/config/env";

import { AxiosInstance } from "axios";
import { UserStorage } from "@/storage/UserStorage";
import { captureApiError } from "./sentry";

// Function to attach authentication headers dynamically
const setupDrypInterceptors = (client: AxiosInstance) => {
	client.interceptors.request.use(config => {
		const token = UserStorage.getToken();
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	});

	client.interceptors.response.use(
		response => response,
		error => {
			if (error?.response?.status === 500) {
				captureApiError("Dryp api", error);
			}

			// Handle 401 (Unauthorized) globally
			// dismiss for Login request
			const isLoginRequest = error?.config?.url === "/Account/Login";
			if (error?.response?.status === 401 && !isLoginRequest) {
				UserStorage.removeToken();
				window.location.href = "/login"; // Redirect to login page
			}
			return Promise.reject(error);
		},
	);
};

export const drypApi = new Api(env.DRYP_API_URL || "", {}, setupDrypInterceptors);
